<template>
    <form
        class="tag-form"
        aria-label="modal-add-tag-form"
        @submit.prevent="handleSubmit"
    >
        <div class="input-wrappper">
            <Select
                v-model="selectValue"
                :options="filteredAppTags"
                :getOptionLabel="(option) => option.name"
                label="Selecione uma das etiquetas cadastradas"
                name="tagSelector"
                :disabled="loading"
                :required="false"
                :helperText="errors.first('tagSelector') || selectError"
                :error="errors.has('tagSelector') || !!selectError"
                v-validate="'required'"
                loadingText="Carrengando..."
                :loading="loadingTags"
            />
        </div>
        <Button class="add-button" type="submit" :disabled="loading">
            {{loading ? 'Adicionando...' : 'Adicionar' }}
        </Button>
    </form>
</template>

<script>
import SellerApi from "../../../services/SellerApi";
import Button from "../../Button.vue";
import Select from "../../Select.vue";

export default {
    components: { Button, Select },
    props: {
        onSuccess: {
            type: Function,
            required: false,
            default: () => {},
        },
        onFail: {
            type: Function,
            required: false,
            default: () => {},
        },
        saleTags: {
            type: Array,
            required: false,
            default: [],
        },
        saleId: String,
        appCode: String,
    },
    data() {
        return {
            selectValue: null,
            loadingTags: false,
            loading: false,
            appTags: [],
            selectError: "",
        };
    },
    computed: {
        filteredAppTags() {
            return this.appTags
                .filter(
                    ({ id: appTagId }) =>
                        !this.saleTags.find(({ tag }) => tag.id === appTagId)
                )
                .sort((a, b) => a.name.localeCompare(b.name));
        },
    },
    methods: {
        handleSubmit() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.loading = true;
                    SellerApi.SaleTag.attachNewTag(this.appCode, this.saleId, {
                        tag: this.selectValue.id,
                    })
                        .then((res) => {
                            this.loading = false;
                            this.onSuccess(res);
                            this.selectValue = "";
                            this.$validator.reset();
                        })
                        .catch((err) => {
                            this.loading = false;
                            this.selectError =
                                "Ocorreu um erro enquanto vinculavamos a etiqueta à venda";
                            this.onFail(err);
                        });
                }
            });
        },
        getAppTags() {
            this.loadingTags = true;
            SellerApi.AppTag.getTags(this.appCode)
                .then((res) => {
                    this.loadingTags = false;
                    this.appTags = res;
                })
                .catch(() => {
                    this.loadingTags = false;
                    this.selectError =
                        "Ocorreu um erro ao obter as etiquetas do aplicativo";
                });
        },
    },
    mounted() {
        this.getAppTags();
    },
};
</script>

<style scoped lang="scss">
.tag-form {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    padding: 0.865rem;

    margin-bottom: 2.5rem;
    background-color: #abadec;
    border-radius: 0.25rem;
}

.input-wrappper {
    flex: 1;
    position: relative;
}

.add-button {
    width: 132px;
    margin-top: 32px !important;
}

.add-button:disabled {
    cursor: not-allowed;
}
</style>
